module.exports = __webpack_public_path__ + "static/img/_dashboard.908932aa.png";